/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon20Regular = forwardRef('ArrowDRadiusDownRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.5 4a6.25 6.25 0 0 0 6.25 6.25h6.34l-4.22-4.22a.75.75 0 0 1 1.06-1.06l4.44 4.439a2.25 2.25 0 0 1 0 3.182l-4.44 4.44a.75.75 0 1 1-1.06-1.061l4.22-4.22H9.75A7.75 7.75 0 0 1 2 4V2.75a.75.75 0 0 1 1.5 0V4Z" })));
});
